import { render, staticRenderFns } from "./subFile.vue?vue&type=template&id=18af49ca&scoped=true&"
import script from "./subFile.vue?vue&type=script&lang=ts&"
export * from "./subFile.vue?vue&type=script&lang=ts&"
import style0 from "./subFile.vue?vue&type=style&index=0&id=18af49ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af49ca",
  null
  
)

export default component.exports